import { MapContainer, TileLayer, ZoomControl } from 'react-leaflet';
import { appConfig } from '@/config/app';
import { useDataStore } from '@/store/dataStore';
import { useUiStore } from '@/store/uiStore';
import type { GeoLevel } from '@/types/geography';
import type { ScoredGeography } from '@/types/insights';
import { CountyLayer } from './CountyLayer';
import { CityLayer } from './CityLayer';
import { ZipLayer } from './ZipLayer';
import { NeighborhoodLayer } from './NeighborhoodLayer';
import { MapLegend } from './MapLegend';
import { MapControls } from './MapControls';
import { MapFlyToController } from './MapFlyToController';
import { MapZoomGeoLevelController } from './MapZoomGeoLevelController';

function ActiveLayer({ geoLevel, geographies }: { geoLevel: GeoLevel; geographies: ScoredGeography[] }) {
  if (geoLevel === 'city') return <CityLayer geographies={geographies} />;
  if (geoLevel === 'zip') return <ZipLayer geographies={geographies} />;
  if (geoLevel === 'neighborhood') return <NeighborhoodLayer geographies={geographies} />;
  return <CountyLayer geographies={geographies} />;
}

export function TexasMap() {
  const geographies = useDataStore((s) => s.geographies);
  const geoLevel = useUiStore((s) => s.geoLevel);

  return (
    <div className="texas-map">
      <MapContainer
        center={[appConfig.defaultCenter.lat, appConfig.defaultCenter.lon]}
        zoom={appConfig.defaultZoom}
        scrollWheelZoom
        zoomControl={false}
        className="texas-map__container"
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <ActiveLayer geoLevel={geoLevel} geographies={geographies} />
        <MapFlyToController />
        <MapZoomGeoLevelController />
        <ZoomControl position="bottomright" />
      </MapContainer>
      <MapControls />
      <MapLegend />
    </div>
  );
}
